import styled from 'styled-components';
import { DialogContent as MDialogContent } from '@material-ui/core';

export const DialogContent = styled(MDialogContent).attrs({
  dividers: true,
})`
  display: flex;
  min-width: 200px;
  min-height: 100px;
  flex-direction: column;
  justify-content: center;
`;
